import { CopyOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import React, { ReactElement, useCallback, useState } from "react";

import { useHistory } from "react-router";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
import { isAllowedService } from "../../utils/services";
import OrderProductList from "./OrderDetails/products";

const TopHeading = ({ total, refetch }): ReactElement => {
  const history = useHistory();
  const [visible, setVisible] = useState(undefined);
  const [selectedProducts, setSelectedProducts] = useState([]);

  const editOrderProducts = useCallback(() => {
    try {
      axios
        .put(
          `${process.env.REACT_APP_ORDER_API}/admin/order/new-order`,
          {
            products: selectedProducts?.map((product) => ({
              productId: product?.id,
              quantity: product?.quantity || 1,
              variationId:
                product?.variations?.[0]?.variationId ||
                product?.variation?.variationId,
            })),
            customerMobileNumber: "string",
            orderNote: "string",

            shippingAddress: "string",
            shippingLocation: {
              latitude: 0,
              longitude: 0,
            },
            type: "string",
          },
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          if (data.status === 200) {
            responseNotification("Order Placed successfully!", "success");
          } else {
            responseNotification(
              data.statusText || "something went wrong",
              "error"
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error, "error");
    }
  }, []);

  return (
    <div className="top-heading-products top-heading-content">
      <div className="container-fluid">
        <div className="row mb-3 d-flex-sb">
          <div className="col-lg-6 col-md-6 no-padding">
            <div className="page-heading-content">
              <h2 className="d-flex-l d-flex-nowrap d-flex-base">
                <b className="nowrap" style={{ whiteSpace: "nowrap" }}>
                  Order List
                </b>
                <span className="d-flex-l ml-1">{total || 0} Orders(s)</span>
              </h2>
            </div>
          </div>
          {isAllowedService(`Orders Order Create`) && (
            <div className="single-button">
              <Button
                type="dashed"
                shape="round"
                size="large"
                onClick={(e) => {
                  e.preventDefault();
                  history.push(`/orders/create`);
                }}
              >
                <CopyOutlined />
                Manual Order
              </Button>
            </div>
          )}
        </div>
      </div>

      <Modal
        title="Place Manual Order"
        centered
        visible={visible}
        onOk={() => {
          setVisible(undefined);
          editOrderProducts();
        }}
        destroyOnClose
        onCancel={() => {
          setVisible(undefined);
        }}
        width={"90%"}
        className="orderProductModal"
      >
        <OrderProductList
          selectedProducts={selectedProducts}
          hubId={undefined} // orderId={(route as any)?.orderId || selectedOrder}
          setSelectedProducts={async (products) => {
            setSelectedProducts(products);
          }}
          orderType={undefined}
        />
      </Modal>
    </div>
  );
};

TopHeading.propTypes = {
  Id: PropTypes.string,
  GetStatus: PropTypes.string,
  GetPrime: PropTypes.string,
  GetFlagship: PropTypes.string,
  GetRocket: PropTypes.string,
  title: PropTypes.string,
};

export default TopHeading;
